module.exports = __webpack_public_path__ + "media/images/features/support/eyecatch-comment-7d8628f0fbb2f492d60186061f4069d4.jpg";